import gql from 'graphql-tag';
const CURTAIN_CALL_ACTIVITY_FRAGMENT = gql `
  fragment CurtainCallActivityFragment on CurtainCallActivity {
    rounds {
      id
      monochromeImage {
        id
        image {
          id
          src
        }
      }
      colorImage {
        id
        image {
          id
          src
        }
      }
      wordAudio {
        id
        audio {
          id
          src
        }
      }
      completeWord
      steps {
        id
        answer
      }
    }
  }
`;
export default CURTAIN_CALL_ACTIVITY_FRAGMENT;
